import { message, Row } from 'antd';
import { Component } from 'react';
import { connect } from "react-redux";
import "../../asset/style/scanner/scanner.css";
import { get, post_response } from "../../helper/request";
import { setDeviceBusy, setDeviceIdle } from '../../redux_actions/device_status.action';
import {
    dropDistanceConfirmed,
    getDefaultConfig,
    receivedPreviewStatus,
    selectionCancelled,
    selectionConfirmed,
    selectionDone,
    setDoTilingAfterScan,
    setDoTilingOnly,
    setFocusPoints,
    setPreviewStatusToConfirmed,
    setScanName,
    setScanSpeed,
    setScanZLevels,
    setScanZStepSize,
    setSpecimenType,
    takePreview,
    unsetDoTilingAfterScan,
    unsetDoTilingOnly,
    updateActionOngoing,
    updatePreviewStatus
} from '../../redux_actions/preview_status.action';
import { RegionSelectionConstants } from "../../redux_constants/region_selection.constant";
import { ScanApiConstant } from '../../redux_constants/scan.constant';
import {
    brushType,
    scanSettingsTypeVals,
    scanSpeed,
    scanWorkflowLoadingMessages,
    SlotRegionSelectionConstants
} from "../../utils/const";
import { getAreaFromBoundingBox } from "./preview_utils";
import BloodPreviewSettingsComp from './scanWorkflow/previewSettingsComponentBlood';
import {
    boundRegions,
    cleanThresholdBorder,
    cleanUpExtra,
    createBorderOnThresholdedCanvas,
    prepareThresholdImageForSave,
    updateImages
} from "./slot_component_utils";

const initState = (id, previewStatus, initRegions) => ({
    regions: initRegions,
    selectedSlot: id,
    previewStatus: previewStatus,
    usingBrush: true,
    brushType: brushType.REDRAW,
    regionArea: 0,
    brushSize: 15,
    slide_name: null,
    reading_barcode: false,
    overrideBlank: false,
    scanSettingsType: scanSettingsTypeVals.GENERAL,
    scanPathSet: false,
    currResponse: {},
    cacheBusterTime: (new Date()).getTime(),
})

class SlotComponentBlood extends Component {

    constructor(props) {
        super(props);
        let region = this.props.preview.region === undefined ? undefined : [this.props.preview.region];
        region = [{
            data: { index: 0 },
            height: 98,
            isChanging: false,
            new: false,
            width: 98,
            x: 1,
            y: 1,
        }];
        this.state = initState(this.props.id, undefined, region);
        this.paint = false;
    }

    updateArea = (regionArea) => {
        this.setState({
            regionArea
        });
    }

    onCanvasUpdate = (regions) => {
        this.setState({
            regions: boundRegions(regions, true),
        });
        let slot_status = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus[this.props.id]
        let previewHeight = ((slot_status||{}).previewResponse||{}).previewHeight
        let previewWidth = ((slot_status||{}).previewResponse||{}).previewWidth
        getAreaFromBoundingBox(regions[0], previewHeight, previewWidth, this.state.selectedSlot, this.props.device_id, this.updateArea);
    }

    onBloodROIConfirm = () => {

        let cache_buster_time = (new Date()).getTime();
        this.setState({cacheBusterTime:cache_buster_time})
        let defaultMaskLocation = ((this.props.preview||{}).previewResponse||{}).previewPath + "default_mask_for_path_blood.bmp?d=" + cache_buster_time;
        defaultMaskLocation = defaultMaskLocation.replace("/media/scandrive/scans/","")

        let uploadLocation = ((this.props.preview||{}).previewResponse||{}).previewPath + "stitched_small.jpg"
        uploadLocation = uploadLocation.replace("/media/scandrive/scans/","")

        updateImages(this.previewCanvas, uploadLocation, this.thresholdCanvas, defaultMaskLocation, this.state.regions, this.cleanupExtraCallback, "/scan-hdd/");
        // this.selectFullRegion();
        // this.onCanvasUpdate(this.state.regions);
    }

    cleanupExtraCallback = () => {
        cleanUpExtra(this.thresholdCanvas, this.thresholdCanvas.getContext('2d'), this.state.regions[0]);
    }
    componentDidMount = () => {

        let newStatus = (this.props.preview || {}).previewStage;
        console.log("??here13", this.previewCanvas)
        if (this.state.selectedSlot !== this.props.id) {
            if (newStatus === RegionSelectionConstants.COARSE_DONE) {
                this.props.dispatch(selectionCancelled(this.props.id));
            }
            let newRegions = newStatus === RegionSelectionConstants.CONFIRMED ? [this.props.preview.region] : undefined;
            this.setState(Object.assign({}, this.state, initState(this.props.id, undefined, newRegions)));
        } else if (this.state.previewStatus !== newStatus && this.previewCanvas != null) {
            if (newStatus === RegionSelectionConstants.FETCHED_IMAGE ||
                newStatus === RegionSelectionConstants.COARSE_DONE ||
                newStatus === RegionSelectionConstants.CONFIRMED) {
                let cache_buster_time = this.state.cacheBusterTime;

                let defaultMaskLocation = ((this.props.preview||{}).previewResponse||{}).previewPath + "default_mask_for_path_blood.bmp?d=" + cache_buster_time;
                defaultMaskLocation = defaultMaskLocation.replace("/media/scandrive/scans/","")

                let uploadLocation = ((this.props.preview||{}).previewResponse||{}).previewPath + "stitched_small.jpg"
                uploadLocation = uploadLocation.replace("/media/scandrive/scans/","")

                updateImages(this.previewCanvas, uploadLocation,
                    this.thresholdCanvas, defaultMaskLocation, this.state.regions,this.cleanupExtraCallback, "/scan-hdd/");
            }
            this.setState(Object.assign({}, this.state, {previewStatus : newStatus}));
        }
        this.selectFullRegion();
        this.onCanvasUpdate(this.state.regions);
    }

    componentDidUpdate(prevProps, prevState) {
        this.updatePreviewBox(prevState);

        if (prevProps.preview.previewResponse.previewStage !== this.props.preview.previewResponse.previewStage && this.props.preview.previewResponse.previewStage === RegionSelectionConstants.FETCHED_IMAGE) {
            this.selectFullRegion();
        }
    }

    updatePreviewBox = (prevState) => {
        let newStatus = (this.props.preview || {}).previewStage;
        if (this.state.selectedSlot !== this.props.id) {
            if (newStatus === RegionSelectionConstants.COARSE_DONE) {
                this.props.dispatch(selectionCancelled(this.props.id));
            }
            let newRegions = newStatus === RegionSelectionConstants.CONFIRMED ? [this.props.preview.region] : undefined;
            this.setState(Object.assign({}, this.state, initState(this.props.id, undefined, newRegions)));
        }
        else if ((this.state.previewStatus !== newStatus ||
            (this.state.brushType !== prevState.brushType &&
                !(prevState.brushType === brushType.BRUSH && this.state.brushType === brushType.ERASER) &&
                !(prevState.brushType === brushType.ERASER && this.state.brushType === brushType.BRUSH)) ||
            this.state.regions !== prevState.regions) && this.previewCanvas != null) {
            if (newStatus === RegionSelectionConstants.FETCHED_IMAGE ||
                newStatus === RegionSelectionConstants.COARSE_DONE ||
                newStatus === RegionSelectionConstants.CONFIRMED) {
                let cache_buster_time = this.state.cacheBusterTime;

                let defaultMaskLocation = ((this.props.preview||{}).previewResponse||{}).previewPath + "default_mask_for_path_blood.bmp?d=" + cache_buster_time;
                defaultMaskLocation = defaultMaskLocation.replace("/media/scandrive/scans/","")
                this.setState({
                    scanPathSet: false,
                });

                let uploadLocation = ((this.props.preview||{}).previewResponse||{}).previewPath + "stitched_small.jpg"
                uploadLocation = uploadLocation.replace("/media/scandrive/scans/","")

                updateImages(this.previewCanvas, uploadLocation,
                    this.thresholdCanvas, defaultMaskLocation, this.state.regions, this.cleanupExtraCallback, "/scan-hdd/");
            }
            this.setState({
                previewStatus : newStatus,
            });
        }
    }

    confirmClicked = () => {
        if ((this.props.preview||{}).previewStage === RegionSelectionConstants.FETCHED_IMAGE) {
            this.props.dispatch(selectionDone(this.props.id));
        } else if ((this.props.preview||{}).previewStage === RegionSelectionConstants.COARSE_DONE || (this.props.preview||{}).previewStage === RegionSelectionConstants.CONFIRMED) {
            prepareThresholdImageForSave(this.thresholdCanvas)
            let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
            let reg = this.state.regions[0];
            let previewHeight = (this.props.preview.previewResponse||{}).previewHeight
            let previewWidth = (this.props.preview.previewResponse||{}).previewWidth
            let x1 = parseInt((reg.x * previewWidth) / 100.0);
            let x2 = parseInt(((reg.x + reg.width) * previewWidth) / 100.0);
            let y1 = parseInt((reg.y * previewHeight) / 100.0);
            let y2 = parseInt(((reg.y + reg.height) * previewHeight) / 100.0);
            let actualReg = [x1, y1, x2, y2]

            let thresholdCanvas = this.thresholdCanvas;
            let x1_box = parseInt((reg.x * thresholdCanvas.width) / 100.0);
            let x2_box = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
            let y1_box = parseInt((reg.y * thresholdCanvas.height) / 100.0);
            let y2_box = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
            let green_box_region = [x1_box,y1_box, x2_box , y2_box];

            let previewDataModified = JSON.parse(JSON.stringify(this.props.preview.previewResponse));
            previewDataModified.speed = "ZSTACK";
            previewDataModified.doTilingOnly = "false";
            previewDataModified.doTilingAfterScan = "false";
            previewDataModified.specimenType = "BLOOD"
            previewDataModified.slideName = this.props.preview.previewResponse.slideName

            this.props.dispatch(selectionConfirmed(this.props.device_id, this.props.id, reg, actualReg,
                imageURLData, previewDataModified.slideName, this.props.startScanning, this.props.cassetteSize, previewDataModified.specimenType,
                "TEN_X", previewDataModified, this.dropDistanceCanvas,green_box_region));
        } else if (this.props.preview.previewStage === RegionSelectionConstants.START_DROP_DISTANCE_SELECTION) {
            this.props.dispatch(dropDistanceConfirmed(this.props.device_id, this.props.id, this.props.preview, this.focusPointsCanvas));
        } else if (this.props.preview.previewStage === RegionSelectionConstants.START_FOCUS_POINTS_SELECTION) {
            this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
        }
    }

    confirmPreviewSettingChanges = () => {
        // if (!this.state.scanPathSet) {
            prepareThresholdImageForSave(this.thresholdCanvas)
            let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
            console.log("image url:", imageURLData)
            let reg = this.state.regions[0];
            let x1 = parseInt((reg.x * this.props.preview.previewResponse.previewWidth) / 100.0);
            let x2 = parseInt(((reg.x + reg.width) * this.props.preview.previewResponse.previewWidth) / 100.0);
            let y1 = parseInt((reg.y * this.props.preview.previewResponse.previewHeight) / 100.0);
            let y2 = parseInt(((reg.y + reg.height) * this.props.preview.previewResponse.previewHeight) / 100.0);
            let actualReg = [x1, y1, x2, y2];

            let thresholdCanvas = this.thresholdCanvas;
            let x1_box = parseInt((reg.x * thresholdCanvas.width) / 100.0);
            let x2_box = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
            let y1_box = parseInt((reg.y * thresholdCanvas.height) / 100.0);
            let y2_box = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
            let green_box_region = [x1_box,y1_box, x2_box , y2_box];

            this.props.dispatch(setDeviceBusy(this.props.device_id));
            this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.CALCULATE_FOCUS_POINTS));

            let previewDataModified = JSON.parse(JSON.stringify(this.props.preview.previewResponse));
            previewDataModified.speed = "ZSTACK";
            previewDataModified.doTilingOnly = "false";
            previewDataModified.doTilingAfterScan = "false";
            previewDataModified.specimenType = "BLOOD"
            previewDataModified.slideName = this.props.preview.previewResponse.slideName

            const url = '/server/devices/' + this.props.device_id + "/send_threshold_image/?slot_id=" + this.props.slot_id+"&recalculate_path="+(!this.state.scanPathSet);
            const data = {
                imgBase64: imageURLData,
                specimenType: "BLOOD",
                objectiveType: "TEN_X",
                actualRegion: actualReg,
                previewData: previewDataModified,
                greenBoxRegion : green_box_region,
            }
            post_response(url, data)
                .then(response => {
                    if (response.status === 200) {
                        this.props.dispatch(setPreviewStatusToConfirmed(this.props.id, reg, actualReg));
                        this.props.dispatch(setFocusPoints(this.props.id, response.data.focusPoints));
                        this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
                        this.setState({
                            scanPathSet: true,
                            currResponse: response,
                        });

                    }
                    else {
                        this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, this.props.id))
                        message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
                    }
                    this.props.dispatch(setDeviceIdle(this.props.device_id));
                })
                .then(response => {
                        this.props.closeExpadedSlideView(this.props.slot_id);
                })
                .catch(err => {
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, this.props.id))
                    this.props.dispatch(setDeviceIdle(this.props.device_id));
                    this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                    message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
                })

        // } else {
        //     this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
        //     this.props.closeExpadedSlideView();
        // }
    }

    onRetakePreview = () => {
        this.clearSelection();
        this.props.dispatch(getDefaultConfig(this.props.device_id, this.props.id));
        this.props.dispatch(takePreview(this.props.device_id, this.props.id));
        this.readbarcode();
    }

    clearSelection = () => {
        this.setState(Object.assign({}, this.state, {
            regions: undefined,
            slide_name: null,
            reading_barcode: false
        }));
        this.props.dispatch(selectionCancelled(this.props.id));
    }

    overrideBlankSlide = () => {
        this.clearSelection();
        this.setState(Object.assign({}, this.state, {
            overrideBlank: true
        }));
    }

    paintCell = (x, y) => {
        const thresholdContext = this.thresholdCanvas.getContext('2d');
        var cellWidth = (parseInt(this.state.brushSize / 2)) * 2;
        thresholdContext.clearRect(x - cellWidth / 2, y - cellWidth / 2, cellWidth, cellWidth);
        thresholdContext.fillStyle = this.state.brushType === brushType.BRUSH ? SlotRegionSelectionConstants.SELETION_FILL.RGBA : SlotRegionSelectionConstants.BLANK.RGBA;
        thresholdContext.fillRect(x - cellWidth / 2, y - cellWidth / 2, cellWidth, cellWidth);
        var img = thresholdContext.getImageData(0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);

        let affectedRegion = {startX:x - cellWidth/2, startY:y - cellWidth/2, endX: x + cellWidth/2, endY: y + cellWidth/2};
        img = cleanThresholdBorder(img, affectedRegion.startX, affectedRegion.startY, affectedRegion.endX, affectedRegion.endY);            
        img = createBorderOnThresholdedCanvas(img, affectedRegion.startX-1, affectedRegion.startY-1, affectedRegion.endX+1, affectedRegion.endY+1);
        thresholdContext.putImageData(img,0,0);
    }

    showBrushOrEraserSize = (event) => {
        const cnvs = this.brushEraserPrevCanvas;
        if(cnvs != null) {
            const cnvsCtx = cnvs.getContext('2d');
            cnvsCtx.clearRect(0, 0, cnvs.width, cnvs.height);
            var rect = cnvs.getBoundingClientRect();
            var canvasx = rect.x;
            var canvasy = rect.y;
            var mousex = parseInt(((event.pageX - canvasx) / rect.width) * cnvs.width);
            var mousey = parseInt(((event.pageY - canvasy) / rect.height) * cnvs.height);
            var cellWidth = (parseInt(this.state.brushSize / 2)) * 2;
            cnvsCtx.clearRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
            cnvsCtx.fillStyle = this.state.brushType === brushType.BRUSH ? "rgba(20,200,20,0.15)" : "rgba(200,20,20,0.15)";
            cnvsCtx.fillRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
            cnvsCtx.lineWidth = 1;
            cnvsCtx.strokeStyle = this.state.brushType === brushType.BRUSH ? "#22ee22" : "#EE2222";
            cnvsCtx.strokeRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
        } else {
            console.warn("brush eraser preview canvas is null");
        }
    }

    paintCanvas = (event) => {
        if (this.paint) {
            var rect = this.thresholdCanvas.getBoundingClientRect();
            var canvasx = rect.x;
            var canvasy = rect.y;
            var mousex = parseInt(((event.pageX - canvasx) / rect.width) * this.thresholdCanvas.width);
            var mousey = parseInt(((event.pageY - canvasy) / rect.height) * this.thresholdCanvas.height);
            this.paintCell(mousex, mousey);

            // Clear any painting outside the region box
            cleanUpExtra(this.thresholdCanvas, this.thresholdCanvas.getContext('2d'), this.state.regions[0]);
        }
        // show preview of current brush or eraser size
        this.showBrushOrEraserSize(event);
    }

    startPainting = (event) => {
        this.paint = true;
        this.paintCanvas(event);
        if (this.state.scanPathSet) {
            this.setState({
                scanPathSet: false,
            });
        }
    }

    stopPainting = () => this.paint = false;

    selectFullRegion = () => {
        this.setState(Object.assign({}, this.state, {
            regions: [
                {
                    data: { index: 0 },
                    height: 100,
                    isChanging: false,
                    new: false,
                    width: 100,
                    x: 0,
                    y: 0,
                }
            ],
            oldState: RegionSelectionConstants.COARSE_DONE
        }));
        this.confirmClicked();
    }

    toggleTiling = (event) => {
        if (event.target.checked) {
            this.props.dispatch(setDoTilingOnly(this.props.id));
        } else {
            this.props.dispatch(unsetDoTilingOnly(this.props.id));
        }
    }

    toggleTilingAfterScan = (event) => {
        if (event.target.checked) {
            this.props.dispatch(setDoTilingAfterScan(this.props.id));
        } else {
            this.props.dispatch(unsetDoTilingAfterScan(this.props.id));
        }
    }

    readbarcode = () => {
        this.setState({
            reading_barcode: true
        });
        let previewPath = this.props.preview.previewResponse.barcodeLocation;
        let url = `/server/devices/${this.props.device_id}/read_barcode/?path=${previewPath}`;
        get(url).then(data => {
            if (data === "") {
                message.warn("No Barcode found on Slide. Please write Slide Name.")
            }
            else{
                this.props.dispatch(setScanName(this.props.id, data))
            }
            this.setState({
                reading_barcode: false
            });
        })
            .catch(err => {
                console.log(err);
            });
    }

    movedBrushSizeSlider = (value) => this.setState({ brushSize : value });

    toggleBrushEraser = () => this.setState((prevState) => ({ usingBrush : !prevState.usingBrush}));

    changeBrushType = (e) => {
        if (e.target.value === brushType.REDRAW) {
            this.setState({
                scanPathSet: false,
            });
        }
        this.setState({
            brushType: e.target.value,
        });
    }

    previewCanvasRef = previewCanvas => this.previewCanvas = previewCanvas;

    thresholdCanvasRef = thresholdCanvas => this.thresholdCanvas = thresholdCanvas;

    brushEraserPrevCanvasRef = brushEraserPrevCanvas => this.brushEraserPrevCanvas = brushEraserPrevCanvas;

    dropDistanceCanvasRef = dropDistanceCanvas => this.dropDistanceCanvas = dropDistanceCanvas;

    focusPointsCanvasRef = focusPointsCanvas => this.focusPointsCanvas = focusPointsCanvas;

    onScanSpeedChange = (event) => {
        this.props.dispatch(setScanSpeed(this.props.id, event.target.value));
    }

    onScanSpeedChangeStack = () => {
        this.props.dispatch(setScanSpeed(this.props.id, scanSpeed.ZSTACK));
    }

    onZLevelsChange = (event) => this.props.dispatch(setScanZLevels(this.props.id, event.target.value));

    onStepSizeChange = (event) => this.props.dispatch(setScanZStepSize(this.props.id, event.target.value));

    onSpecimenTypeChange = (event) => {
        this.props.dispatch(setSpecimenType(this.props.id, event.target.value));
        let cache_buster_time = this.state.cacheBusterTime;

        let defaultMaskLocation = ((this.props.preview||{}).previewResponse||{}).previewPath + "default_mask_for_path_blood.bmp?d=" + cache_buster_time;
        defaultMaskLocation = defaultMaskLocation.replace("/media/scandrive/scans/","")

        let uploadLocation = ((this.props.preview||{}).previewResponse||{}).previewPath + "stitched_small.jpg"
        uploadLocation = uploadLocation.replace("/media/scandrive/scans/","")

        updateImages(this.previewCanvas, uploadLocation,
            this.thresholdCanvas, defaultMaskLocation, this.state.regions, this.cleanupExtraCallback, "/scan-hdd/");

        this.setState({
            scanPathSet: false,
        });
    }

    onScanNameChange = (event) => {
        let slide_name = event.target.value;
        this.setState({
            slide_name: slide_name
        }, () => this.props.dispatch(setScanName(this.props.id, slide_name)));
    }


    render() {
        let status = (this.props.preview || {}).previewStage;
        let allowPainting = false;
        let slotComp = null;

        if (this.state.brushType !== brushType.REDRAW) {
            allowPainting = true;
        }

        if (this.props.showSummary) {
            slotComp = this.props.summaryDiv;
        } else if (this.props.id === -1 || status === RegionSelectionConstants.NOT_STARTED) {
        } else if (status !== RegionSelectionConstants.ERRORED_OUT) {
            slotComp = (
                <div className="relative-parent properties-width">
                    <Row style={{height:'inherit'}}>
                        <BloodPreviewSettingsComp showBrushOrEraserSize={this.showBrushOrEraserSize} brushType={this.state.brushType} brushSize={this.state.brushSize} changeBrushType={this.changeBrushType}
                                                  movedBrushSizeSlider={this.movedBrushSizeSlider} status={status} previewCanvasRef={this.previewCanvasRef}
                                                  thresholdCanvasRef={this.thresholdCanvasRef} brushEraserPrevCanvasRef={this.brushEraserPrevCanvasRef} regions={this.state.regions} onCanvasUpdate={this.onCanvasUpdate}
                                                  allowPainting={allowPainting} startPainting={this.startPainting} paintCanvas={this.paintCanvas}
                                                  stopPainting={this.stopPainting} dropDistanceCanvas={this.dropDistanceCanvas}
                                                  dropDistanceCanvasRef={this.dropDistanceCanvasRef} focusPointsCanvas={this.focusPointsCanvas}
                                                  focusPointsCanvasRef={this.focusPointsCanvasRef} id={this.props.id} device_id={this.props.device_id}
                                                  onScanNameChange={this.onScanNameChange} readbarcode={this.readbarcode} reading_barcode={this.state.reading_barcode} onSpecimenTypeChange={this.onSpecimenTypeChange}
                                                  onScanSpeedChange={this.onScanSpeedChange} onScanSpeedChangeStack={this.onScanSpeedChangeStack} onZLevelsChange={this.onZLevelsChange}
                                                  onStepSizeChange={this.onStepSizeChange} toggleTiling={this.toggleTiling} toggleTilingAfterScan={this.toggleTilingAfterScan}
                                                  regionArea={this.state.regionArea} slot_id={this.props.slot_id} slideId={this.props.slideId}
                                                  closeExpadedSlideView={this.props.closeExpadedSlideView} onPreviewFinalization={this.props.onPreviewFinalization}
                                                  expandedView={this.props.expandedView} bloodData={this.props.preview} onBloodROIConfirm={this.onBloodROIConfirm}
                                                  confirmPreviewSettingChanges={this.confirmPreviewSettingChanges}/>
                    </Row>
                </div>
            )
        } else {
            slotComp = <Row>Error</Row>;
        }

        return (
            <div>
                {slotComp}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        // preview: state.previewStatusReducer[ownProps.id],
        deviceStatus: state.deviceStatusReducer,
        slot_id: ownProps.slot_id,
        bloodConfig: state.bloodConfigReducer,
    };
};

export default connect(mapStateToProps)(SlotComponentBlood);
